/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocationModel } from '../player/models/location';
import { CommonApiService } from '../shared/common-api.service';

export interface LocationsResponse {
  total: number;
  payload: LocationModel[];
}

export interface SingleLocationResponse {
  payload: LocationModel;
}
/**
 * Service to handle a collection of stations.
 */
@Injectable()
export class LocationsService {
  constructor(private http: HttpClient, private commonApiService: CommonApiService) {}

  /**
   * Provides a list of stations given the user is authenticated.
   *
   * @returns Observable<any>
   */
   getLocations(): Observable<any> {
    // const httpParams: HttpParams = new HttpParams();
    // httpParams.append('isPlaylists', true);
    const url = `locations?isPlaylists=true`;
    // eslint-disable-next-line max-len
    return this.http.get<LocationsResponse>(this.commonApiService.getUrl(url)).pipe(map(res => res.payload));
  }

  updateLocation(location: LocationModel): Observable<LocationModel> {
    return this.http
      .put<SingleLocationResponse>(this.commonApiService.getUrl('locations'), location, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      })
      .pipe(map(res => res.payload));
  }
}
